import styled, { css } from 'styled-components';

import theme from '../theme';

export const ViewContainer = styled.div`
  background: ${theme.backgroundColor};
  overflow: scroll;
  position: relative;
  display: flex;
  flex-flow: column;
  height: 100vh;

  ${Styles.desktop`
    flex-flow: row;
  `}
`;

const withSlimCardsCss = css`
  overflow: scroll;
  height: 45%;

  ${Styles.desktop`
    height: 100%;
  `}
`;

export const SearchContainer = styled.div<{ withSlimCards?: boolean }>`
  order: 2;
  width: 100%;
  ${p => p.withSlimCards && withSlimCardsCss}

  ${Styles.desktop`
    order: 1;
    width: 23rem;
    overflow: scroll;
  `}
`;

export const MapViewContainer = styled.div<{ hide?: boolean }>`
  background: ${Styles.color.white};
  display: ${p => (p.hide ? 'none' : 'flex')};
  flex: 1 1 0;
  justify-content: center;
  position: relative;
  order: 1;

  ${Styles.desktop`
    height: 100%;
    order: 2;
  `}
`;
